import { Box, BoxProps, useMediaQuery, useTheme } from '@mui/material';
import { useMemo } from 'react';

type Props = BoxProps & {
  icon: string;
  style?: string;
  size?: 'large' | 'medium' | 'small';
};

export default function Icon({ icon, style = 'far', size = 'medium', onClick, sx }: Props) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  // Logic for responsive icon font size. Will be finished later
  const fontSize = useMemo(() => {
    if (size === 'large') {
      return isMobile ? '20px' : '30px';
    }
    if (size === 'medium') {
      return isMobile ? '20px' : '20px';
    }
    return '15px';
  }, [size, isMobile]);

  return <Box onClick={onClick} component="i" className={`${style} ${icon} fa-fw`} sx={{...sx, fontSize: `${fontSize} !important`, color: theme.palette.common.white }}  />;
}
